import axios from "@/axios";

export const namespaced = true;

export const state = {
  lineItems: [],
  lineItemReceiptStatus: false,
  lineItemErrors: [],
};

export const getters = {
  lineItems: (state) => {
    let lineItems = [];
   
    if (state.lineItems) {
      let lineItemNumbers = state.lineItems
        .filter((lineItem) => parseInt(lineItem.itemNumber))
        .map((lineItem) => {
          return { ...lineItem, itemNumber: parseInt(lineItem.itemNumber) };
        });

      let lineItemStrings = state.lineItems.filter(
        (lineItem) => !parseInt(lineItem.itemNumber)
      );

      lineItemNumbers = lineItemNumbers.sort();
      if (lineItemStrings) {
        lineItemStrings = lineItemStrings.sort();
        lineItems = lineItemNumbers.concat(lineItemStrings);
      } else {
        lineItems = lineItemNumbers;
      }

      return lineItems;
    }
  },
  lineItemReceiptStatus: (state) => state.lineItemReceiptStatus,
  lineItemErrors: (state) => state.lineItemErrors,
};

export const mutations = {
  SET_LINE_ITEMS: (state, response) => {
    state.lineItems = response.data;
  },
  SET_LINE_ITEM_RECEIPT_STATUS(state, status) {
    state.lineItemReceiptStatus = status;
  },
  SET_ERRORS(state, data) {
    state.lineItemErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.lineItemErrors = [];
  }
};

export const actions = {
  async getLineItems({ commit, state }, orderId) {
    var id = orderId;
    commit(
      "SET_LINE_ITEMS",
      await axios.get(`/api/receiptitems/order/${orderId}`)
    );
  },
  async getLineItemReceiptStatus({ commit }, id) {
    commit("CLEAR_ERRORS");
    if (id == 0) {
      commit("SET_LINE_ITEM_RECEIPT_STATUS", false);
    } else {
      return await axios
        .get("/api/receiptitems/status/" + id)
        .then(({ data }) => {
          if(data && data.length === 0) {
            commit("SET_LINE_ITEM_RECEIPT_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
          commit("SET_LINE_ITEM_RECEIPT_STATUS", false);
            //commit("SET_ERRORS", data);     
        }
        });
    }
  },
  async saveLineItems({ state }, items) {
    return await axios.post("api/receiptitems/all", items);
  }
};
